import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

import Begin from "./pages/Begin/Begin";
import Aura from "./pages/Aura/Aura";
import Onboarding from "./pages/Onboarding/Onboarding";
import ProblemDescription from "./pages/ProblemDescription/ProblemDescription";
import Processing from "./pages/Processing/Processing";
import Validation from "./pages/Validation/Validation";
import ChallengeDescription from "./pages/ChallengeDescription/ChallengeDescription";
import ExpectedResult from "./pages/ExpectedResult/ExpectedResult";
import ImagineSolution from "./pages/ImagineSolution/ImagineSolution";
import Review from "./pages/Review/Review";
import Masterplan from "./pages/Masterplan/Masterplan";
import Final from "./pages/Final/Final";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      {/* Key by pathname so exit animations run before the next page enters */}
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Aura />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/problem-description" element={<ProblemDescription />} />
        <Route path="/processing" element={<Processing />} />
        <Route path="/validation" element={<Validation />} />
        <Route path="/describe-challenge" element={<ChallengeDescription />} />
        <Route path="/expected-result" element={<ExpectedResult />} />
        <Route path="/imagine-solution" element={<ImagineSolution />} />
        <Route path="/review" element={<Review />} />
        <Route path="/masterplan" element={<Masterplan />} />
        <Route path="/masterplan/:id" element={<Masterplan />} />
        <Route path="/final" element={<Final />} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
